<template>
	<div>
		<div class="main-content-hotel" id="booking-detail-hotel">
			<loading :active.sync="isLoading" :is-full-page="false"></loading>
			<div id="printSection">
				<!-- Contact -->
				<div v-if="data.contact" class="card-item">
					<div class="card-item-header d-flex justify-content-between align-items-center">
						<label slot="header" class="card-item-title">{{$t('_BOOKING_DETAIL.CONTACT.TITLE')}}</label>
						<button @click="back" class="main-btn btn-pmirary not-print">{{$t('BACK')}}</button>
					</div>
					<div class="card-item-content d-flex justify-content-between">
						<div class="flex-1">
							<div class="booking-detail-info-wrapper">
								<span
									class="booking-detail-label booking-detail-label-width"
								>{{$t('_BOOKING_DETAIL.CONTACT.NAME')}}</span>
								<span class="booking-detail-content">{{data.contact.name}}</span>
							</div>
							<div class="booking-detail-info-wrapper">
								<span
									class="booking-detail-label booking-detail-label-width"
								>{{$t('_BOOKING_DETAIL.CONTACT.PHONE')}}</span>
								<span class="booking-detail-content">{{data.contact.phone}}</span>
							</div>
							<div class="booking-detail-info-wrapper">
								<span
									class="booking-detail-label booking-detail-label-width"
								>{{$t('_BOOKING_DETAIL.CONTACT.GROUP_NAME_TOUR')}}</span>
								<span class="booking-detail-content">{{data.bookingName}}</span>
							</div>
						</div>
						<v-divider vertical class="mx-5 my-0"></v-divider>
						<div class="flex-1">
							<div class="booking-detail-info-wrapper">
								<span
									class="booking-detail-label booking-detail-label-width"
								>{{$t('_BOOKING_DETAIL.CONTACT.EMAIL')}}</span>
								<span class="booking-detail-content">{{data.contact.email}}</span>
							</div>
							<div class="booking-detail-info-wrapper">
								<span
									class="booking-detail-label booking-detail-label-width"
								>{{$t('_BOOKING_DETAIL.CONTACT.AGENT_NAME')}}</span>
								<span class="booking-detail-content">{{data.contact.agentName}}</span>
							</div>
						</div>
					</div>
				</div>

				<!-- Booking detail -->
				<div class="mt-5 card-item">
					<div class="card-item-header">
						<label
							slot="header"
							class="card-item-title"
						>{{$t('_BOOKING_DETAIL.BOOKING_DETAIL.TITLE')}}</label>
					</div>
					<div class="card-item-content d-flex justify-content-between">
						<div class="flex-1">
							<div class="booking-detail-info-wrapper">
								<span
									class="booking-detail-label booking-detail-label-width"
								>{{$t('_BOOKING_DETAIL.BOOKING_DETAIL.CODE')}}</span>
								<span class="booking-detail-content text-green">{{data.code}}</span>
							</div>
							<div class="booking-detail-info-wrapper">
								<span
									class="booking-detail-label booking-detail-label-width"
								>{{$t('_BOOKING_DETAIL.BOOKING_DETAIL.STATUS')}}</span>
								<span
									class="booking-detail-content text-green"
									:style="{color: getStatusColor(data.status)}"
								>{{getBookingStatusText(data.status)}}</span>
							</div>
							<div class="booking-detail-info-wrapper">
								<span
									class="booking-detail-label booking-detail-label-width"
								>{{$t('_BOOKING_DETAIL.BOOKING_DETAIL.CREATED')}}</span>
								<span
									class="booking-detail-content"
								>{{formatDateTime(data.created, 'YYYY-MM-DD hh:mm A', 'DD/MM/YYYY HH:mm')}}</span>
							</div>
						</div>
						<v-divider vertical class="mx-5 my-0"></v-divider>
						<div class="flex-1">
							<div class="booking-detail-info-wrapper">
								<span
									class="booking-detail-label booking-detail-label-width"
								>{{$t('_BOOKING_DETAIL.BOOKING_DETAIL.CHECK_IN')}}</span>
								<span
									class="booking-detail-content"
								>{{formatDateTime(data.checkIn, 'YYYY-MM-DD', 'DD/MM/YYYY')}}</span>
							</div>
							<div class="booking-detail-info-wrapper">
								<span
									class="booking-detail-label booking-detail-label-width"
								>{{$t('_BOOKING_DETAIL.BOOKING_DETAIL.CHECK_OUT')}}</span>
								<span
									class="booking-detail-content"
								>{{formatDateTime(data.checkOut, 'YYYY-MM-DD', 'DD/MM/YYYY')}}</span>
							</div>
							<div class="booking-detail-info-wrapper">
								<span
									class="booking-detail-label booking-detail-label-width"
								>{{$t('_BOOKING_DETAIL.BOOKING_DETAIL.UPDATED')}}</span>
								<span
									class="booking-detail-content"
								>{{formatDateTime(data.updated, 'YYYY-MM-DD hh:mm A', 'DD/MM/YYYY HH:mm')}}</span>
							</div>
						</div>
					</div>
				</div>

				<!-- Begin Room detail -->
				<template>
					<div :key="i" class="mt-5 card-item">
						<div class="card-item-header">
							<label
								slot="header"
								class="card-item-title"
							>{{$t('BOOKING_INFO')}}</label>
						</div>
						<v-row class="table-header m-0">
							<v-col class="p-0" md="5">
								<span class="booking-detail-label">{{$t('_BOOKING_DETAIL.ROOM.NAME')}}</span>
							</v-col>
							<v-col class="py-0">
								<v-row>
									<v-col class="p-0">
										<span class="booking-detail-label">{{$t('DETAIL')}}</span>
									</v-col>
									<v-col class="p-0 text-right">
										<span class="booking-detail-label">{{$t('_BOOKING_DETAIL.ROOM.UNIT_PRICE')}} ({{data.currency}})</span>
									</v-col>
									<v-col class="p-0 text-center">
										<span class="booking-detail-label">{{$t('QUANTITY')}}</span>
									</v-col>
									<v-col class="p-0 text-right">
										<span class="booking-detail-label">{{$t('_BOOKING_DETAIL.ROOM.TOTAL')}} ({{data.currency}})</span>
									</v-col>
								</v-row>
							</v-col>
						</v-row>
						<div class="card-item-content">
							<template v-for="(room, i) in bookingGroup" >
								<v-row :key="i" class="m-0">
									<v-col class="p-0" md="5" v-if="room.element.length > 1">
										<b class="booking-detail-content">{{$t('ROOM')}}: {{room.objectOverview.title}}</b> <br> <span class="fs-12 color-8c8c8c"> ({{room.objectOverview.roomTitle}})</span>
										<p class="m-0"><b-button variant="link" class="p-0 txt-underline" @click="openModalDetailRoom(room.element)">{{$t('DETAIL')}}</b-button></p>
									</v-col>
									<v-col class="p-0" md="5" v-if="room.element.length === 1">
										<b class="booking-detail-content">{{$t('ROOM')}}: {{room.objectOverview.title}}</b> <br> <span class="fs-12 color-8c8c8c"> ({{room.objectOverview.roomTitle}})</span>
										<p class="m-0" v-if="room.element[0].guestName">{{$t('_BOOKING_DETAIL.CONTACT.NAME')}}: {{room.element[0].guestName}}</p>
										<p class="m-0">{{$t('QUANTITY')}}: {{room.element[0].adult}} {{$t('ADULT')}}, {{room.element[0].children}} {{$t('CHILDREN')}}</p>
									</v-col>
									<v-col class="py-0" v-if="room.element.length === 1">
										<v-row>
											<v-col class="p-0">
												<span class="booking-detail-label">{{$t('UNIT_ROOM_PRICE')}}</span>
											</v-col>
											<v-col class="p-0 text-right">
												<span class="booking-detail-content">{{formatCurrency(room.element[0].unitPrice)}}</span>
											</v-col>
											<v-col class="p-0 text-center">
												<span class="booking-detail-content">{{room.element[0].quantity}}</span>
											</v-col>
											<v-col class="p-0 text-right">
												<span class="booking-detail-content">{{formatCurrency(room.element[0].totalLine)}}</span>
											</v-col>
										</v-row>
										<v-row v-if="room.element[0].lineAdult.length > 0">
											<v-col class="p-0">
												<span class="booking-detail-label">{{$t('EXTRA_ADULT')}}</span>
											</v-col>
											<v-col class="p-0 text-right">
												<span class="booking-detail-content">{{formatCurrency(room.element[0].lineAdult[0].unitPrice)}}</span>
											</v-col>
											<v-col class="p-0 text-center">
												<span class="booking-detail-content">{{room.element[0].lineAdult[0].quantity}}</span>
											</v-col>
											<v-col class="p-0 text-right">
												<span class="booking-detail-content">{{formatCurrency(room.element[0].lineAdult[0].totalLine)}}</span>
											</v-col>
										</v-row>
										<v-row v-if="room.element[0].lineChild.length > 0">
											<v-col class="p-0">
												<span class="booking-detail-label">{{$t('EXTRA_CHILD')}}</span>
											</v-col>
											<v-col class="p-0 text-right">
												<span class="booking-detail-content">{{formatCurrency(room.element[0].lineChild[0].unitPrice)}}</span>
											</v-col>
											<v-col class="p-0 text-center">
												<span class="booking-detail-content">{{room.element[0].lineChild[0].quantity}}</span>
											</v-col>
											<v-col class="p-0 text-right">
												<span class="booking-detail-content">{{formatCurrency(room.element[0].lineChild[0].totalLine)}}</span>
											</v-col>
										</v-row>
										<template v-if="room.element[0].include.length > 0">
											<v-row v-for="(inc, indexinc) in room.element[0].include" :key="indexinc">
												<v-col class="p-0">
													<span class="booking-detail-label">{{inc.title}}</span>
												</v-col>
												<v-col class="p-0 text-right">
													<span class="booking-detail-content"></span>
												</v-col>
												<v-col class="p-0 text-center">
													<span class="booking-detail-content"></span>
												</v-col>
												<v-col class="p-0 text-right">
													<span class="booking-detail-content text-success">{{formatCurrency(inc.totalLine)}}</span>
												</v-col>
											</v-row>
										</template>
										<template v-if="room.element[0].lineService.length > 0">
											<v-row v-for="(sv, indexsv) in room.element[0].lineService" :key="indexsv">
												<v-col class="p-0">
													<span class="booking-detail-label">{{sv.title}} </span>
													<p class="m-0 text-secondary fs-12">({{formatDateTime(sv.serviceDetail.startDate, '', 'DD/MM/YYYY')}} - {{formatDateTime(sv.serviceDetail.endDate, '', 'DD/MM/YYYY')}})</p>
												</v-col>
												<v-col class="p-0 text-right">
													<span class="booking-detail-content">{{formatCurrency(sv.unitPrice)}}</span>
												</v-col>
												<v-col class="p-0 text-center">
													<span class="booking-detail-content">{{sv.quantity}}</span>
												</v-col>
												<v-col class="p-0 text-right">
													<span class="booking-detail-content">{{formatCurrency(sv.totalLine)}}</span>
												</v-col>
											</v-row>
										</template>
									</v-col>
									<v-col class="py-0" v-if="room.element.length > 1">
										<v-row>
											<v-col class="p-0">
												<span class="booking-detail-label">{{$t('UNIT_ROOM_PRICE')}}</span>
											</v-col>
											<v-col class="p-0 text-right">
												<span class="booking-detail-content">{{formatCurrency(room.objectOverview.unitPrice)}}</span>
											</v-col>
											<v-col class="p-0 text-center">
												<span class="booking-detail-content">{{room.objectOverview.quantity}}</span>
											</v-col>
											<v-col class="p-0 text-right">
												<span class="booking-detail-content">{{formatCurrency(room.objectOverview.totalLine)}}</span>
											</v-col>
										</v-row>
										<v-row v-if="room.objectOverview.extraAdultPrice > 0">
											<v-col class="p-0">
												<span class="booking-detail-label">{{$t('EXTRA_ADULT')}}</span>
											</v-col>
											<v-col class="p-0 text-right">
												<span class="booking-detail-content">{{formatCurrency(room.objectOverview.extraAdultPrice/room.objectOverview.quantityAdult)}}</span>
											</v-col>
											<v-col class="p-0 text-center">
												<span class="booking-detail-content">{{room.objectOverview.quantityAdult}}</span>
											</v-col>
											<v-col class="p-0 text-right">
												<span class="booking-detail-content">{{formatCurrency(room.objectOverview.extraAdultPrice)}}</span>
											</v-col>
										</v-row>
										<v-row v-if="room.objectOverview.extraChildPrice > 0">
											<v-col class="p-0">
												<span class="booking-detail-label">{{$t('EXTRA_CHILD')}}</span>
											</v-col>
											<v-col class="p-0 text-right">
												<span class="booking-detail-content">{{formatCurrency(room.objectOverview.extraChildPrice/room.objectOverview.quantityChild)}}</span>
											</v-col>
											<v-col class="p-0 text-center">
												<span class="booking-detail-content">{{room.objectOverview.quantityChild}}</span>
											</v-col>
											<v-col class="p-0 text-right">
												<span class="booking-detail-content">{{formatCurrency(room.objectOverview.extraChildPrice)}}</span>
											</v-col>
										</v-row>
										<v-row v-if="room.objectOverview.servicePrice> 0">
											<v-col class="p-0"><span class="booking-detail-label">{{$t('_BOOKING_DETAIL.SERVICE.TITLE')}}</span></v-col>
											<v-col class="p-0 text-right">{{formatCurrency(room.objectOverview.servicePrice)}}</v-col>
										</v-row>
										<v-row v-if="room.objectOverview.discountPrice> 0">
											<v-col class="p-0"><span class="booking-detail-label">{{$t('_BOOKING_DETAIL.PROMOTION.TITLE')}}</span></v-col>
											<v-col class="p-0 text-right">{{formatCurrency(room.objectOverview.discountPrice)}}</v-col>
										</v-row>
									</v-col>
								</v-row>
								
								<p class="border-bottom pt-1 pb-3"></p>
							</template>
							<v-row>
								<v-col class="py-0">
								</v-col>
								<v-col class="py-0" md="5">
									<v-row>
										<v-col class="py-0 color-8c8c8c">{{$t('UNIT_ROOM_PRICE')}}</v-col>
										<v-col class="py-0 text-right">{{formatCurrency(data.roomPrice)}}</v-col>
									</v-row>
									<v-row>
										<v-col class="py-0 color-8c8c8c">{{$t('SURCHARGE')}}</v-col>
										<v-col class="py-0 text-right">{{formatCurrency(data.extra)}}</v-col>
									</v-row>
									<v-row>
										<v-col class="py-0 color-8c8c8c">{{$t('_BOOKING_DETAIL.SERVICE.TITLE')}}</v-col>
										<v-col class="py-0 text-right">{{formatCurrency(data.servicePrice)}}</v-col>
									</v-row>
									<v-row>
										<v-col class="py-0 color-8c8c8c">{{$t('_BOOKING_DETAIL.PROMOTION.TITLE')}}</v-col>
										<v-col class="py-0 text-success text-right">{{formatCurrency(data.promotionPrice)}}</v-col>
									</v-row>
									<v-row v-if="ojbGiftCode !== null">
										<v-col class="py-0 color-8c8c8c">
											<p class="p-gift text-success">
												{{data.giftCode.code}}
											</p>
										</v-col>
										<v-col class="py-0 text-success text-right">{{formatCurrency(ojbGiftCode.totalLine)}}</v-col>
									</v-row>
									<div v-if="ojbGiftCode !== null">
										<p class="text-right m-0">
											<span class="color-808080 fs-12">
												(<span v-if="data.giftCode.distcountType === 1">{{data.giftCode.discount}}%</span><span v-if="data.giftCode.distcountType === 2">{{formatCurrency(data.giftCode.discount)}} {{data.currency}}</span>
												<span v-if="data.giftCode.applyType === 1"> {{$t('APPLY_ON_TOTAL_BOOKING')}})</span>
												<span v-if="data.giftCode.applyType === 3"> {{$t('APPLY_ON_TOTAL_SERVICE')}})</span>
												<span v-if="data.giftCode.applyType === 2"> {{$t('APPLY_ON_TOTAL_ROOM_RATE')}})</span>
											</span>
										</p>
									</div>
								</v-col>
							</v-row>
							<p class="border-bottom pt-1 pb-3"></p>
							<v-row>
								<v-col class="py-0">
								</v-col>
								<v-col class="py-0" md="5">
									<v-row>
										<v-col class="py-0 color-8c8c8c"><strong>{{$t('_BOOKING_DETAIL.TOTAL')}} ({{data.currency}})</strong></v-col>
										<v-col class="py-0 text-right"><strong>{{formatCurrency(data.total)}}</strong></v-col>
									</v-row>
									<p class="text-secondary fs-12 text-right">{{$t('PRICES_INCLUDE_TAXES_FEES')}}</p>
								</v-col>
							</v-row>
						</div>
					</div>
				</template>
				<!-- End Room detail -->

				<!-- Payment history -->
				<div class="mt-5 card-item">
					<div class="card-item-header">
						<label slot="header" class="card-item-title">{{$t('_BOOKING_DETAIL.PAYMENT_LOG.TITLE')}}</label>
					</div>
					<div class="card-item-content payment-history-card">
						<v-row>
							<v-col class="py-0 booking-detail-info-wrapper border-right">
								<span class="booking-detail-label">{{$t('_BOOKING_DETAIL.PAYMENT_LOG.METHOD')}}</span>
							</v-col>
							<v-col class="py-0 booking-detail-info-wrapper border-right">
								<span class="booking-detail-label">{{$t('_BOOKING_DETAIL.PAYMENT_LOG.TRANS_DATE')}}</span>
							</v-col>
							<v-col class="py-0 booking-detail-info-wrapper border-right">
								<span class="booking-detail-label">{{$t('_BOOKING_DETAIL.PAYMENT_LOG.TRANS_NO')}}</span>
							</v-col>
							<v-col class="py-0 booking-detail-info-wrapper border-right">
								<span class="booking-detail-label">{{$t('_BOOKING_DETAIL.PAYMENT_LOG.AMOUNT')}}</span>
							</v-col>
							<v-col class="py-0 booking-detail-info-wrapper">
								<span class="booking-detail-label">{{$t('_BOOKING_DETAIL.PAYMENT_LOG.RES_MSG')}}</span>
							</v-col>
						</v-row>
						<template v-for="(item, i) in data.paymentLogs">
							<v-row :key="i">
								<v-col class="py-0 border-right">
									<span class="booking-detail-content text-black">{{item.method}}</span>
								</v-col>
								<v-col class="py-0 border-right">
									<span
										class="booking-detail-content"
									>{{formatDateTime(item.transDate, 'YYYY-MM-DD HH:mm:ss SSS', 'DD/MM/YYYY')}}</span>
								</v-col>
								<v-col class="py-0 border-right">
									<span class="booking-detail-content">{{item.transNo}}</span>
								</v-col>
								<v-col class="py-0 border-right">
									<span class="booking-detail-content">{{formatCurrency(item.amount)}}</span>
								</v-col>
								<v-col class="py-0">
									<span class="booking-detail-content">{{item.resMsg}}</span>
								</v-col>
							</v-row>
						</template>
					</div>
					<div class="card-item-content d-flex justify-content-end border-top">
						<div>
							<div>
								<span class="booking-detail-label">{{$t('_BOOKING_DETAIL.PAID')}}</span>
							</div>
							<div>
								<span class="booking-detail-label">{{$t('_BOOKING_DETAIL.UNPAID')}}</span>
							</div>
						</div>
						<div class="booking-detail-total-wrapper">
							<div>
								<span>{{formatCurrency(data.paid)}} {{data.currency}}</span>
							</div>
							<div>
								<span>{{formatCurrency(data.unpaid)}} {{data.currency}}</span>
							</div>
						</div>
					</div>
				</div>

				<div class="mt-5 card-item">
					<div class="card-item-header">
						<label slot="header" class="card-item-title">{{$t('_BOOKING_DETAIL.NOTE')}}</label>
					</div>
					<div class="card-item-content">
						<v-row class="m-0">
							<v-col cols="12" class="border br-8">
								{{data.notes}}
							</v-col>
						</v-row>
						<v-row class="not-print">
							<v-col cols="12" class="text-right">
								<button
									@click="printBooking"
									class="main-btn btn-secondary not-print"
								>{{$t('_BOOKING_DETAIL.EXPORT')}}</button>
								<button
									v-if="isContractCancel"
									@click="deactiveDialog = true"
									class="ml-3 main-btn btn-danger not-print"
								>{{$t('_BOOKING_DETAIL.CANCEL')}}</button>
							</v-col>
						</v-row>
					</div>
				</div>
			</div>
		</div>
		<v-dialog v-model="deactiveDialog" max-width="400" content-class="dialog-confirm">
			<v-card>
				<span>{{$t('_BOOKING_DETAIL.CONFIRM_CANCEL')}}</span>
				 <textarea class="form-control mt-4 no-resize" 
						v-on:keyup="countdown" 
						v-model="dataCancel.reason" 
						:rows="6"
						:error.sync="error.reason.error"
						:placeholder="$t('_BOOKING_DETAIL.CONFIRM_REASON')"/>
					<div class="warn-text-container">
						<div class="warn-text">
							<div v-if="remainingCount <= 0">
								<span class='text-right text-small'>{{$t('OVER_CHARACTER')}}</span>
							</div>
						</div>
						<span class='text-right text-small text-count'>{{currentCount}} / {{maxCount}}</span>
					</div>
				<v-row>
					<v-col cols="12" class="btn-right-wrapper">
					<div v-if="remainingCount <= 0">
						<button
							class="main-btn btn-secondary mr-5"
							@click="deactiveDialog = false"
						>{{$t('CLOSE')}}</button>
						<button
							disabled
							class="main-btn btn-secondary mr-5"
							@click="validateCancelBooking"
						>{{$t('_TRAVEL_AGENT.CONFIRM')}}</button>
					</div>
					<div v-else>  
						<button
							class="main-btn btn-secondary mr-5"
							@click="deactiveDialog = false"
						>{{$t('CLOSE')}}</button>
						<button
							class="main-btn btn-pmirary"
							@click="validateCancelBooking"
						>{{$t('_TRAVEL_AGENT.CONFIRM')}}</button>
					</div>
					</v-col>
				</v-row>
			</v-card>
		</v-dialog>
		<b-modal id="modal-detail-room" size="xl" hide-footer title="Chi tiết từng gói bán">
			<div class="headertableDetail" v-if="data">
				<v-row class="text-secondary m-0">
					<v-col class="mt-2"  md="4"><b >{{$t('_BOOKING_DETAIL.ROOM.NAME')}}</b></v-col>
					<v-col>
						<v-row>
							<v-col class="mt-2"><b>{{$t('DETAIL')}}</b></v-col>
							<v-col class="mt-2 text-right"><b>{{$t('_BOOKING_DETAIL.ROOM.UNIT_PRICE')}} ({{data.currency}})</b></v-col>
							<v-col class="mt-2 text-right"><b>{{$t('QUANTITY')}}</b></v-col>
							<v-col class="mt-2 text-right" style="padding-left: 0"><b>{{$t('_BOOKING_DETAIL.ROOM.TOTAL')}} ({{data.currency}})</b></v-col>
						</v-row>
					</v-col>
				</v-row>
			</div>
			<div v-for="(item, index) in arrModal" :key="index" class="">
				<v-row class="mb-3 mt-3">
					<v-col md="4">
						<p class="m-0 fs-16"><b>{{$t('ROOM')}} {{item.indexRoom}}: {{item.title}}</b> <span class="text-secondary fs-12">({{item.roomTitle}})</span></p>
						<p class="m-0" v-if="item.guestName">{{$t('_BOOKING_DETAIL.CONTACT.NAME')}}: {{item.guestName}}</p>
						<p class="m-0">{{$t('QUANTITY')}}: {{item.adult}} {{$t('ADULT')}}, {{item.children}} {{$t('CHILDREN')}}</p>
					</v-col>
					<v-col>
						<v-row>
							<v-col>{{$t('UNIT_ROOM_PRICE')}}</v-col>
							<v-col class="text-right">{{formatCurrency(+item.unitPrice)}}</v-col>
							<v-col class="text-right">{{item.quantity}}</v-col>
							<v-col class="text-right">{{formatCurrency(item.totalLine)}}</v-col>
						</v-row>
						<v-row v-if="item.lineAdult.length > 0">
							<v-col>{{$t('EXTRA_ADULT')}}</v-col>
							<v-col class="text-right">{{formatCurrency(+item.lineAdult[0].unitPrice)}}</v-col>
							<v-col class="text-right">{{item.lineAdult[0].quantity}}</v-col>
							<v-col class="text-right">{{formatCurrency(item.lineAdult[0].totalLine)}}</v-col>
						</v-row>
						<v-row v-if="item.lineChild.length > 0">
							<v-col>{{$t('EXTRA_CHILD')}}</v-col>
							<v-col class="text-right">{{formatCurrency(+item.lineChild[0].unitPrice)}}</v-col>
							<v-col class="text-right">{{item.lineChild[0].quantity}}</v-col>
							<v-col class="text-right">{{formatCurrency(item.lineChild[0].totalLine)}}</v-col>
						</v-row>
						<template v-if="item.include.length > 0">
							<v-row v-for="(inc, indexsv) in item.include" :key="indexsv">
								<v-col>{{inc.title}}</v-col>
								<v-col class="text-right"></v-col>
								<v-col class="text-right"></v-col>
								<v-col class="text-right text-success">{{formatCurrency(inc.totalLine)}}</v-col>
							</v-row>
						</template>
						<template v-if="item.lineService.length > 0">
							<v-row v-for="(sv, indexsv) in item.lineService" :key="indexsv">
								<v-col>{{sv.title}} <br> <span class="fs-12 text-secondary">({{formatDateTime(sv.serviceDetail.startDate, '', 'DD/MM/YYYY')}} - {{formatDateTime(sv.serviceDetail.endDate, '', 'DD/MM/YYYY')}})</span></v-col>
								<v-col class="text-right">{{formatCurrency(+sv.unitPrice)}}</v-col>
								<v-col class="text-right">{{sv.quantity}}</v-col>
								<v-col class="text-right">{{formatCurrency(sv.totalLine)}}</v-col>
							</v-row>
						</template>
					</v-col>
				</v-row>
				<p class="border-bottom"></p>
			</div>
		</b-modal>
	</div>
</template>

<style lang="scss" scoped>
.col-12 {
	-webkit-box-flex: 0;
	-ms-flex: 0 0 100%;
	flex: 0 0 100%;
	max-width: 100%;
}
.warn-text-container{
	margin-top: 10px;
}
.warn-text{
	display: inline-block;
	color: #d9390d;
	width: 80%;
}
.text-count{
	position: relative;
	top: 2px;
	float: right;
	display: inline-block;
}
.table-header{
	background: #E8E8E8;
	padding: 12px 24px;
	font-weight: bold;
}
.p-gift{
	border: 1px solid #28a745;
	border-radius: 4px;
	padding: 0 10px;
	margin: 0;
}
.br-8 {
	border-radius: 8px;
}
</style>

<script>
import PageHeader from "@/components/Utils/Header.vue";
import LeftMenu from "@/components/Utils/LeftMenu.vue";
import Input from "@/components/Utils/Input.vue";
import Select from "@/components/Utils/Select.vue";
import DatePicker from "@/components/Utils/DatePicker.vue";
import Textarea from "@/components/Utils/Textarea.vue";
import { getBkDtError } from "@/_helpers/config.js";
import {
	_validateFormI18n,
	_alert,
	_formatDateTime,
	_formatCurrency
} from "@/_helpers/function.js";
import { service } from "@/_services/Booking/booking.service.js";
import { bookingService } from "@/_services/supplier/booking.service.js";
import { getCssText } from "@/_helpers/css-text.js";

export default {
	components: {
		"page-header": PageHeader,
		"left-menu": LeftMenu,
		"input-text": Input,
		"select-text": Select,
		"date-picker": DatePicker,
		"input-textarea": Textarea
	},
	data() {
		return {
			maxCount: 255,
			remainingCount: 255,
			currentCount: 0,
			disable: false,
			hasError: false,
			isLoading: false,
			data: {},
			listBookingStatus: [
				{
					id: 1,
					key: "CANCEL",
					value: this.$t("_BOOKING.STATUS.CANCEL"),
					color: "#FA541C"
				},
				{
					id: 2,
					key: "AWAIT_PAYMENT",
					value: this.$t("_BOOKING.STATUS.AWAIT_PAYMENT"),
					color: "#FAAD14"
				},
				{
					id: 3,
					key: "CLOSE",
					value: this.$t("_BOOKING.STATUS.CLOSE"),
					color: "#722ED1"
				},
				{
					id: 4,
					key: "IN_SERVICE",
					value: this.$t("_BOOKING.STATUS.IN_SERVICE"),
					color: "#007AFF"
				},
				{
					id: 5,
					key: "PAYMENT_FAILED",
					value: this.$t("_BOOKING.STATUS.PAYMENT_FAILED"),
					color: "#FA541C"
				},
				{ id: 6, key: "CONFIRM", value: this.$t("_BOOKING.STATUS.CONFIRM"), color: "#52C41A" },
				{
					id: 7,
					key: "AWAIT_FULLY_PAYMENT",
					value: this.$t("_BOOKING.STATUS.AWAIT_FULLY_PAYMENT"),
					color: "#FAAD14"
				},
				{
					id: 8,
					key: "VOID",
					value: this.$t("_BOOKING.STATUS.VOID"),
					color: "#FA541C"
				}
			],
			// contractMayCancelStatus: [2, 5, 6, 7],
			contractMayCancelStatus: [
				"AWAIT_PAYMENT",
				"PAYMENT_FAILED",
				"CONFIRM",
				"AWAIT_FULLY_PAYMENT"
			],
			dataCancel: {
				reason: ""
			},
			error: getBkDtError(),
			isContractCancel: false,
			deactiveDialog: false,
			ojbGiftCode: null,
			total: 0,
			bookingGroup: [],
			arrModal: [],
		};
	},
	created() {
		this.initialize();
	},
	methods: {
		formatDateTime(value, inputFormat, outputFormat) {
			if (!value) {
				return "";
			}
			return _formatDateTime(value, inputFormat, outputFormat);
		},
		formatCurrency(amount) {
			return _formatCurrency(amount);
		},
		// Run when start
		initialize() {
			let requests = [];
			if (!this.$route.params || !this.$route.params.code) {
				this.back();
			}
			this.data.code = this.$route.params.code;
			requests.push(this.getBookingDetail(this.data.code));
			this.isLoading = true;
			Promise.all(requests).finally(() => (this.isLoading = false));
		},
		// Go back
		back() {
			this.$router.back();
		},
		// Get booking status text
		getBookingStatusText(key) {
			const result = this.listBookingStatus.find(item => item.key === key);
			return result ? result.value : "";
		},
		// load booking detail
		async getBookingDetail(code) {
			return await bookingService.getBookingDetailTicket(code).then(res => {
				if (res.responseCode === 0) {
					this.data = res.data;
					const arr_room = [];
					this.data.line = [];
					this.data.roomPrice = 0;
					this.data.servicePrice = 0;
					this.data.promotionPrice = 0;
					this.data.extra = 0;
					this.data.bookingLine.forEach(element => {
						if (element.lineType === 0) {
							arr_room.push(element);
							this.data.roomPrice += element.totalLine;
						} else if (element.lineType === 1) {
							this.data.promotionPrice += element.totalLine;
						} else if (element.lineType === 2) {
							this.data.servicePrice += element.totalLine;
						} else if (element.lineType === 3) {
							this.ojbGiftCode = element;
						} else if (element.lineType === 4 || element.lineType === 5) {
							this.data.extra += element.totalLine;
						}
						this.total += element.totalLine;
					});
					arr_room.forEach(r => {
						r.lineService = [];
						r.lineAdult = [];
						r.lineChild = [];
						r.include = [];
						this.data.bookingLine.forEach(line => {
							if (line.roomPlanId === r.roomPlanId && r.lineIndex === line.lineIndex && line.lineType === 2) {
								r.lineService.push(line);
							}
							if (line.roomPlanId === r.roomPlanId && r.lineIndex === line.lineIndex && line.lineType === 4) {
								r.lineAdult.push(line);
							}
							if (line.roomPlanId === r.roomPlanId && r.lineIndex === line.lineIndex && line.lineType === 5) {
								r.lineChild.push(line);
							}
							if (line.roomPlanId === r.roomPlanId && r.lineIndex === line.lineIndex && line.lineType === 1) {
								r.include.push(line);
							}
						});
					});
					this.data.line = [...arr_room];
					const objectGroupbyRoomplanId = this.groupBy(this.data.line, 'roomPlanId');
					const arrGroupbyRoomplanId = [];
					let indexbefore = 0;
					for (const key in objectGroupbyRoomplanId) {
						if (Object.prototype.hasOwnProperty.call(objectGroupbyRoomplanId, key)) {
							const element = objectGroupbyRoomplanId[key];
							let objectOverview = {
								title: '',
								roomTitle: '',
								unitPrice: 0,
								totalLine: 0,
								quantity: 0,
								extraAdultPrice: 0,
								extraChildPrice: 0,
								quantityAdult: 0,
								quantityChild: 0,
								servicePrice: 0,
								discountPrice: 0,
							};
							element.forEach((e, index) => {
								e.indexRoom = indexbefore + index + 1;
								if (element.length === 1) {
									objectOverview.title = `${indexbefore + 1}: ` + e.title;
								} else {
									objectOverview.title = `${indexbefore + 1} - ${indexbefore + element.length}: ` + e.title;
								}

								objectOverview.roomTitle = e.roomTitle;
								objectOverview.unitPrice = e.unitPrice;
								objectOverview.totalLine += e.totalLine;
								objectOverview.quantity += e.quantity;
								e.lineAdult.forEach(ad => {
									objectOverview.extraAdultPrice += ad.totalLine;
									objectOverview.quantityAdult += ad.quantity;
								});
								e.lineChild.forEach(ch => {
									objectOverview.extraChildPrice += ch.totalLine;
									objectOverview.quantityChild += ch.quantity;
								});
								e.include.forEach(dc => {
									objectOverview.discountPrice += dc.totalLine;
								});
								e.lineService.forEach(sv => {
									objectOverview.servicePrice += sv.totalLine;
								});
							});
							arrGroupbyRoomplanId.push({ objectOverview, element });
							indexbefore = element.length;
						}
					}
					this.bookingGroup = [...arrGroupbyRoomplanId];
					// Check booking status
					if (this.contractMayCancelStatus.indexOf(this.data.status) > -1) {
						this.isContractCancel = true;
					} else {
						this.isContractCancel = false;
					}
				} else {
					_alert(res, this.$t(res.data), false);
				}
			});
		},
		groupBy(xs, key) {
			return xs.reduce(function (rv, x) {
				(rv[x[key]] = rv[x[key]] || []).push(x);
				return rv;
			}, {});
		},
		openModalDetailRoom(room) {
			this.arrModal = room;
			this.$root.$emit('bv::show::modal', 'modal-detail-room');
		},
		// print booking
		printBooking() {
			// printJS({ printable: 'printSection', type: 'html', targetStyles: ['*'] });
			// Get HTML to print from element
			const prtHtml = document.getElementById("printSection").innerHTML;
			// Get all stylesheets HTML
			let stylesHtml = `<style type="text/css">.not-print {display: none}</style>`;
			// Open the print window
			const WinPrint = window.open(
				"",
				"",
				"left=0,top=0,width=0,height=0,toolbar=0,scrollbars=0,status=0"
			);
			WinPrint.document.write(`<!DOCTYPE html>
			<html>
				<head>
					${stylesHtml}
					${getCssText()}
				</head>
				<body style="padding: 20px; background: #f6f6f6; visible: hidden;">
					${prtHtml}
				</body>
			</html>`);
			WinPrint.document.close();
			this.$nextTick().then(() => {
				WinPrint.focus();
				WinPrint.print();
				WinPrint.close();
			});
		},
		countdown() {
			this.remainingCount = this.maxCount - this.dataCancel.reason.length;
			this.currentCount = this.dataCancel.reason.length;
		},
		// Validate booking, then cancel
		validateCancelBooking() {
			let { isValid, error } = _validateFormI18n(this.dataCancel, this.error);
			this.error = error;
			if (!isValid) return false;
			this.cancelBooking(this.data.code, this.dataCancel.reason);
		},
		// Cancel booking
		cancelBooking(code, reason) {
			let temp = {
				code: code,
				reason: reason
			};
			this.isLoading = true;
			service
				.cancelBooking(temp)
				.then(res => {
					if (res.responseCode === 0) {
						// this.initialize();
						_alert(res, this.$t(res.data));
					} else {
						this.deactiveDialog = false;
						_alert(res, this.$t(res.data), false);
					}
				})
				.finally(() => (this.isLoading = false));
		},
		getStatusColor(status) {
			const selected = this.listBookingStatus.find(item => item.key === status);
			return selected ? selected.color : status;
		}
	}
};
</script>
<style lang="scss" scoped>
.room-card {
	.row {
		.col {
			&:nth-of-type(1) {
				width: 16%;
				max-width: 16%;
			}
			&:nth-of-type(2) {
				width: 16%;
				max-width: 16%;
			}
			&:nth-of-type(3) {
				width: 16%;
				max-width: 16%;
			}
			&:nth-of-type(4) {
				width: 16%;
				max-width: 16%;
			}
			&:nth-of-type(5) {
				width: 10%;
				max-width: 10%;
			}
			&:nth-of-type(6) {
				width: 10%;
				max-width: 10%;
			}
			&:nth-of-type(7) {
				width: 16%;
				max-width: 16%;
			}
		}
	}
}
.payment-history-card {
	.row {
		.col {
			&:nth-of-type(1) {
				width: 22%;
				max-width: 22%;
			}
			&:nth-of-type(2) {
				width: 16%;
				max-width: 16%;
			}
			&:nth-of-type(3) {
				width: 26%;
				max-width: 26%;
			}
			&:nth-of-type(4) {
				width: 12%;
				max-width: 12%;
			}
			&:nth-of-type(5) {
				width: 25%;
				max-width: 25%;
			}
		}
	}
}
.border-right {
	border-right: solid thin rgba(0, 0, 0, 0.12) !important;
}
</style>